import {
  // @ts-ignore
  windowUndefined,
} from '../../../helpers/serverRenderingUtils';

const BRAZE_API_URL = 'sdk.iad-06.braze.com';

/**
 * Braze (formerly known as appboy)
 * initialization guide: https://www.braze.com/docs/developer_guide/platform_integration_guides/web/initial_sdk_setup/#install-cdn
 *
 * 1. Creates a script tag and loads Braze SDK (appboy.min.js)
 * 2. Defines `script.onload` callback and adds methods to `window.appboy`
 * 3. Initializes Braze service and opens a session in the `onload` function
 *
 */

export function initializeBraze(apiKey: string) {
  const script = document.createElement('script');
  script.src = 'https://js.appboycdn.com/web-sdk/3.1/appboy.min.js';
  script.async = true;
  script.onload = () => {
    // @ts-ignore
    window.appboy = {};
    window.appboyQueue = [];
    for (
      let s = 'DeviceProperties Card Card.prototype.dismissCard Card.prototype.removeAllSubscriptions Card.prototype.removeSubscription Card.prototype.subscribeToClickedEvent Card.prototype.subscribeToDismissedEvent Banner CaptionedImage ClassicCard ControlCard ContentCards ContentCards.prototype.getUnviewedCardCount Feed Feed.prototype.getUnreadCardCount ControlMessage InAppMessage InAppMessage.SlideFrom InAppMessage.ClickAction InAppMessage.DismissType InAppMessage.OpenTarget InAppMessage.ImageStyle InAppMessage.Orientation InAppMessage.TextAlignment InAppMessage.CropType InAppMessage.prototype.closeMessage InAppMessage.prototype.removeAllSubscriptions InAppMessage.prototype.removeSubscription InAppMessage.prototype.subscribeToClickedEvent InAppMessage.prototype.subscribeToDismissedEvent FullScreenMessage ModalMessage HtmlMessage SlideUpMessage User User.Genders User.NotificationSubscriptionTypes User.prototype.addAlias User.prototype.addToCustomAttributeArray User.prototype.getUserId User.prototype.incrementCustomUserAttribute User.prototype.removeFromCustomAttributeArray User.prototype.setAvatarImageUrl User.prototype.setCountry User.prototype.setCustomLocationAttribute User.prototype.setCustomUserAttribute User.prototype.setDateOfBirth User.prototype.setEmail User.prototype.setEmailNotificationSubscriptionType User.prototype.setFirstName User.prototype.setGender User.prototype.setHomeCity User.prototype.setLanguage User.prototype.setLastKnownLocation User.prototype.setLastName User.prototype.setPhoneNumber User.prototype.setPushNotificationSubscriptionType InAppMessageButton InAppMessageButton.prototype.removeAllSubscriptions InAppMessageButton.prototype.removeSubscription InAppMessageButton.prototype.subscribeToClickedEvent display display.automaticallyShowNewInAppMessages display.destroyFeed display.hideContentCards display.showContentCards display.showFeed display.showInAppMessage display.toggleContentCards display.toggleFeed changeUser destroy getDeviceId initialize isPushBlocked isPushGranted isPushPermissionGranted isPushSupported logCardClick logCardDismissal logCardImpressions logContentCardsDisplayed logCustomEvent logFeedDisplayed logInAppMessageButtonClick logInAppMessageClick logInAppMessageHtmlClick logInAppMessageImpression logPurchase openSession registerAppboyPushMessages removeAllSubscriptions removeSubscription requestContentCardsRefresh requestFeedRefresh requestImmediateDataFlush resumeWebTracking setLogger stopWebTracking subscribeToContentCardsUpdates subscribeToFeedUpdates subscribeToInAppMessage subscribeToNewInAppMessages toggleAppboyLogging trackLocation unregisterAppboyPushMessages wipeData'.split(
          ' '
        ),
        i = 0;
      i < s.length;
      i++
    ) {
      for (
        // eslint-disable-next-line no-var,vars-on-top
        var m = s[i], k = window.appboy, l = m.split('.'), j = 0;
        j < l.length - 1;
        // eslint-disable-next-line no-plusplus
        j++
      )
        // @ts-ignore
        k = k[l[j]];

      // @ts-ignore
      // eslint-disable-next-line no-new-func,block-scoped-var,block-scoped-var
      k[l[j]] = new Function(
        `return function ${m.replace(
          /\./g,
          '_'
        )}(){window.appboyQueue.push(arguments); return true}`
      )();
    }
    window.appboy.getCachedContentCards = () =>
      new window.appboy.ContentCards();
    window.appboy.getCachedFeed = () => new window.appboy.Feed();
    window.appboy.getUser = () => new window.appboy.User();
    initializeAndOpenSession(apiKey);
  };
  document.body.appendChild(script);
}

function initializeAndOpenSession(apiKey: string) {
  if (!windowUndefined) {
    window.appboy.initialize(apiKey, {
      baseUrl: BRAZE_API_URL,
    });
    window.appboy.openSession();
  }
}
